var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
import WKT from 'ol/format/WKT';
import { ActivityService } from 'app/services/activity.service';
import { JstsService } from 'app/services/jsts.service';
import { LineString } from 'ol/geom';
import { FlipRoadService } from 'app/services/flip-road.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
var ResolutionRAOComponent = /** @class */ (function () {
    function ResolutionRAOComponent(activityService, attrIndexService, flipRoadService, jstsService, mapSharedService, resoCenterService, resoQcService) {
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.flipRoadService = flipRoadService;
        this.jstsService = jstsService;
        this.mapSharedService = mapSharedService;
        this.resoCenterService = resoCenterService;
        this.resoQcService = resoQcService;
        this.edit = new EventEmitter();
        this.rules = [];
        this.firstEndConnected = true;
        this.secondEndConnected = true;
        this.parityLeftColName = 'grd_parity_l';
        this.parityRightColName = 'grd_parity_r';
    }
    ResolutionRAOComponent.prototype.onEdit = function (idx, e) {
        this.resoCenterService.onEditRecord(this.centerlineList[idx], e.col);
        //
        var side;
        if (e.col.prop === this.fromAddrLeftCol.prop || e.col.prop === this.toAddrLeftCol.prop) {
            side = 'left';
        }
        else {
            side = 'right';
        }
        this.updateRAO(side);
        this.updateParity(this.centerlineList[idx], side);
        // let changedCols = [e.col];
        this.edit.emit();
    };
    // attachToLarger(side?: CenterlineSide) {
    // 	if (!side) {
    // 		side = 'left';
    // 	}
    // 	let parityColName: string, fromCol: ResoCenterCol, toCol: ResoCenterCol;
    // 	if (side === 'left') {
    // 		parityColName = this.parityLeftColName;
    // 		fromCol = this.fromAddrLeftCol;
    // 		toCol = this.toAddrLeftCol;
    // 	} else {
    // 		parityColName = this.parityRightColName;
    // 		fromCol = this.fromAddrRightCol;
    // 		toCol = this.toAddrRightCol;
    // 	}
    // 	const parity = this.centerlineList[0].props[parityColName];
    // 	const attachTo = this.centerlineList[1].props[fromCol.prop];
    // 	let value = this.centerlineList[0].props[toCol.prop];
    // 	if (parity === 'E') {
    // 		value = attachTo % 2 === 0 ? attachTo - 2 : attachTo - 1;
    // 	} else if (parity === 'O') {
    // 		value = attachTo % 2 === 0 ? attachTo - 1 : attachTo - 2;
    // 	} else {
    // 		value = attachTo - 1;
    // 	}
    // 	this.centerlineList[0].props[toCol.prop] = value;
    // 	this.onEdit(0, {
    // 		val: value,
    // 		col: toCol
    // 	});
    // }
    // attachToLower(side?: CenterlineSide) {
    // 	if (!side) {
    // 		side = 'left';
    // 	}
    // 	let parityColName: string, fromCol: ResoCenterCol, toCol: ResoCenterCol;
    // 	if (side === 'left') {
    // 		parityColName = this.parityLeftColName;
    // 		fromCol = this.fromAddrLeftCol;
    // 		toCol = this.toAddrLeftCol;
    // 	} else {
    // 		parityColName = this.parityRightColName;
    // 		fromCol = this.fromAddrRightCol;
    // 		toCol = this.toAddrRightCol;
    // 	}
    // 	const parity = this.centerlineList[1].props[parityColName];
    // 	const attachTo = this.centerlineList[0].props[toCol.prop];
    // 	let value = this.centerlineList[1].props[fromCol.prop];
    // 	if (parity === 'E') {
    // 		value = attachTo % 2 === 0 ? attachTo + 2 : attachTo + 1;
    // 	} else if (parity === 'O') {
    // 		value = attachTo % 2 === 0 ? attachTo + 1 : attachTo + 2;
    // 	} else {
    // 		value = attachTo + 1;
    // 	}
    // 	this.centerlineList[1].props[fromCol.prop] = value;
    // 	this.onEdit(1, {
    // 		val: value,
    // 		col: fromCol
    // 	});
    // }
    ResolutionRAOComponent.prototype.attach = function (e) {
        var lineIdx = this.centerlineList.findIndex(function (l) { return l.id === e.id; });
        var line = this.centerlineList[lineIdx];
        var attachToLine = lineIdx === 0 ? this.centerlineList[1] : this.centerlineList[0];
        var parityColName, fromCol, toCol;
        var errorCol;
        var attachToCol;
        var isIncrease;
        if (e.side === 'left') {
            fromCol = this.fromAddrLeftCol;
            toCol = this.toAddrLeftCol;
            parityColName = this.parityLeftColName;
            //
            errorCol = line.isFromLeftError ? this.fromAddrLeftCol : this.toAddrLeftCol;
            attachToCol = line.isFromLeftError ? this.toAddrLeftCol : this.fromAddrLeftCol;
            isIncrease = line.isFromLeftError ? true : false;
        }
        else if (e.side === 'right') {
            fromCol = this.fromAddrRightCol;
            toCol = this.toAddrRightCol;
            parityColName = this.parityRightColName;
            //
            errorCol = line.isFromRightError ? this.fromAddrRightCol : this.toAddrRightCol;
            attachToCol = line.isFromRightError ? this.toAddrRightCol : this.fromAddrRightCol;
            isIncrease = line.isFromRightError ? true : false;
        }
        var parity = line.props[parityColName];
        var attachToValue = attachToLine.props[attachToCol.prop];
        var value = line.props[errorCol.prop];
        var delta1 = isIncrease ? 1 : -1;
        var delta2 = isIncrease ? 2 : -2;
        if (parity === 'E') {
            value = attachToValue % 2 === 0 ? attachToValue + delta2 : attachToValue + delta1;
        }
        else if (parity === 'O') {
            value = attachToValue % 2 === 0 ? attachToValue + delta1 : attachToValue + delta2;
        }
        else {
            value = attachToValue + delta1;
        }
        line.props[errorCol.prop] = value;
        this.onEdit(lineIdx, {
            val: value,
            col: errorCol
        });
    };
    ResolutionRAOComponent.prototype.flipFromTo = function (e) {
        var lineIdx = this.centerlineList.findIndex(function (l) { return l.id === e.id; });
        var line = this.centerlineList[lineIdx];
        var fromCol, toCol;
        if (e.side === 'left') {
            fromCol = this.fromAddrLeftCol;
            toCol = this.toAddrLeftCol;
        }
        else if (e.side === 'right') {
            fromCol = this.fromAddrRightCol;
            toCol = this.toAddrRightCol;
        }
        var fromVal = line.props[fromCol.prop];
        var toVal = line.props[toCol.prop];
        line.props[fromCol.prop] = toVal;
        line.props[toCol.prop] = fromVal;
        this.onEdit(lineIdx, {
            val: fromVal,
            col: toCol
        });
        this.onEdit(lineIdx, {
            val: toVal,
            col: fromCol
        });
    };
    ResolutionRAOComponent.prototype.jointChange = function (e) {
        var direction;
        var side = e.side;
        var lineIdx = e.idx;
        var line = this.centerlineList[lineIdx];
        var fromCol, toCol, parityColName;
        if (side === 'left') {
            fromCol = this.fromAddrLeftCol;
            toCol = this.toAddrLeftCol;
            parityColName = this.parityLeftColName;
        }
        else {
            fromCol = this.fromAddrRightCol;
            toCol = this.toAddrRightCol;
            parityColName = this.parityRightColName;
        }
        // Changed fields for first line and second line
        var firstCol, secondCol;
        if (lineIdx === 0) {
            if (line.direction === 'E' || line.direction === 'S') {
                firstCol = toCol;
                secondCol = fromCol;
                direction = 'increase';
            }
            else {
                firstCol = fromCol;
                secondCol = toCol;
                direction = 'decrease';
            }
        }
        else if (lineIdx === 1) {
            if (line.direction === 'E' || line.direction === 'S') {
                firstCol = toCol;
                secondCol = fromCol;
                direction = 'decrease';
            }
            else {
                firstCol = fromCol;
                secondCol = toCol;
                direction = 'increase';
            }
        }
        else {
            return;
        }
        // const getDeltaByParity = (parity: ParityValue, value) => {
        // 	if (parity !== 'E' && parity !== 'O') {
        // 		return 1;
        // 	}
        // 	const valueParity = value % 2 === 0 ? 'E' : 'O'
        // 	let delta = valueParity === parity ? 2 : 1; 
        // 	if (direction === 'decrease') {
        // 		delta = delta * -1;
        // 	}
        // 	return delta;
        // }
        var firstValue = this.centerlineList[0].props[firstCol.prop];
        var firstParity = this.centerlineList[0].props[parityColName];
        var firstDelta = this.resoCenterService.getDeltaValueByParity(firstValue, firstParity, direction);
        //
        var secondValue = this.centerlineList[1].props[secondCol.prop];
        var secondParity = this.centerlineList[1].props[parityColName];
        var secondDelta = this.resoCenterService.getDeltaValueByParity(secondValue, secondParity, direction);
        // const secondValueParity: 'E' | 'O' = secondValue % 2 === 0 ? 'E' : 'O';
        // const secondDelta = secondValueParity === secondParity ? 2 : 1; 
        this.centerlineList[0].props[firstCol.prop] = firstValue + firstDelta;
        this.centerlineList[1].props[secondCol.prop] = secondValue + secondDelta;
        this.onEdit(0, {
            val: firstValue,
            col: firstCol
        });
        this.onEdit(1, {
            val: secondValue,
            col: secondCol
        });
    };
    // If side isn't passed, check both sides
    ResolutionRAOComponent.prototype.updateRAO = function (side) {
        // const rao = this.centerlineList.find((l, idx) => {
        // 	if (idx >= this.centerlineList.length - 1) {
        // 		return;
        // 	}
        // 	if (l.props[parityColName] === 'Z' || this.centerlineList[idx + 1].props[parityColName] === 'Z') {
        // 		return;
        // 	}
        // 	if (l.props[toCol.prop] >= this.centerlineList[idx + 1].props[fromCol.prop]) {
        // 		return true;
        // 	}
        // })
        var setClean = function (line) {
            if (!side || side === 'left') {
                line.isFromLeftError = null;
                line.isToLeftError = null;
            }
            if (!side || side === 'right') {
                line.isFromRightError = null;
                line.isToRightError = null;
            }
        };
        var line1 = this.centerlineList[0];
        var line2 = this.centerlineList[1];
        setClean(line1);
        setClean(line2);
        var parityColName = side === 'left' ? this.parityLeftColName : this.parityRightColName;
        var fromCol;
        var toCol;
        var check = function (s) {
            if (line1.props[parityColName] === 'Z' || line2.props[parityColName] === 'Z') {
                return;
            }
            var measureSmallerLine, measureLargerLine;
            if (line1.props[fromCol.prop] < line2.props[fromCol.prop] && line1.props[toCol.prop] > line2.props[fromCol.prop]) {
                measureSmallerLine = line1;
                measureLargerLine = line2;
            }
            else if (line1.props[fromCol.prop] > line2.props[fromCol.prop] && line1.props[fromCol.prop] < line2.props[toCol.prop]) {
                measureSmallerLine = line2;
                measureLargerLine = line1;
            }
            else {
                if (line1.props[fromCol.prop] === line2.props[fromCol.prop]) {
                    if (line1.direction === line2.direction) {
                        if (line1.direction === 'E' || line1.direction === 'S') {
                            measureSmallerLine = line1;
                            measureLargerLine = line2;
                        }
                        else {
                            measureSmallerLine = line2;
                            measureLargerLine = line1;
                        }
                    }
                    else {
                        measureSmallerLine = line1.props[toCol.prop] < line2.props[toCol.prop] ? line1 : line2;
                        measureLargerLine = line1.props[toCol.prop] < line2.props[toCol.prop] ? line2 : line1;
                    }
                }
            }
            if (!measureSmallerLine || !measureLargerLine) {
                return;
            }
            if (s === 'left') {
                measureSmallerLine.isToLeftError = true;
                measureLargerLine.isFromLeftError = true;
            }
            else {
                measureSmallerLine.isToRightError = true;
                measureLargerLine.isFromRightError = true;
            }
        };
        // Check left
        if (!side || side === 'left') {
            fromCol = this.fromAddrLeftCol;
            toCol = this.toAddrLeftCol;
            check('left');
        }
        // Check right
        if (!side || side === 'right') {
            fromCol = this.fromAddrRightCol;
            toCol = this.toAddrRightCol;
            check('right');
        }
    };
    ResolutionRAOComponent.prototype.updateParity = function (centerline, side) {
        var _this = this;
        var changedCols = [];
        var update = function (fromProp, toProp, parityProp) {
            var from = centerline.props[fromProp];
            var to = centerline.props[toProp];
            var parity = _this.resoQcService.getParity(from, to);
            if (centerline.props[parityProp] !== parity) {
                centerline.props[parityProp] = parity;
                changedCols.push(parityProp);
                _this.resoCenterService.onEditRecord(centerline, {
                    prop: parityProp
                });
            }
        };
        var fromCol, toCol, parityColName;
        if (!side || side === 'left') {
            fromCol = this.fromAddrLeftCol;
            toCol = this.toAddrLeftCol;
            parityColName = this.parityLeftColName;
            update(fromCol.prop, toCol.prop, parityColName);
        }
        if (!side || side === 'right') {
            fromCol = this.fromAddrRightCol;
            toCol = this.toAddrRightCol;
            parityColName = this.parityRightColName;
            update(fromCol.prop, toCol.prop, parityColName);
        }
        return changedCols;
    };
    ResolutionRAOComponent.prototype.onFeedChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layerCateCode, cols, centerlineList, wktFormat, wkt1, wkt2, geom1, geom2, additionalLine;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.resolverFeed) {
                            return [2 /*return*/];
                        }
                        layerCateCode = Object.keys(this.resolverFeed.feed)[0];
                        return [4 /*yield*/, this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode)];
                    case 1:
                        cols = _a.sent();
                        return [4 /*yield*/, this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode)];
                    case 2:
                        centerlineList = _a.sent();
                        // This has to go after transformItemList because details are updated in it
                        this.resoCenterService.setRelatedIds(this.resolverFeed);
                        this.centerlineList = centerlineList;
                        this.centerlineList.forEach(function (l) {
                            _this.calculateDirection(l);
                        });
                        this.calculateRelativePosition();
                        if (this.centerlineList[1].relativePosition === 'left' || this.centerlineList[1].relativePosition === 'upper') {
                            // Switch position in array
                            this.centerlineList = [this.centerlineList[1], this.centerlineList[0]];
                        }
                        wktFormat = new WKT();
                        wkt1 = this.centerlineList[0].props[this.attrIndexService.geomColManual];
                        wkt2 = this.centerlineList[1].props[this.attrIndexService.geomColManual];
                        geom1 = wkt1 ? wktFormat.readGeometry(wkt1) : null;
                        geom2 = wkt2 ? wktFormat.readGeometry(wkt2) : null;
                        this.checkRoadsConnected(geom1, geom2);
                        this.checkRoadsRings(geom1, geom2, this.centerlineList[0], this.centerlineList[1]);
                        //
                        this.fromAddrLeftCol = cols.find(function (c) { return c.prop === _this.attrIndexService.fromAddrLeftColName; });
                        this.toAddrLeftCol = cols.find(function (c) { return c.prop === _this.attrIndexService.toAddrLeftColName; });
                        this.fromAddrRightCol = cols.find(function (c) { return c.prop === _this.attrIndexService.fromAddrRightColName; });
                        this.toAddrRightCol = cols.find(function (c) { return c.prop === _this.attrIndexService.toAddrRightColName; });
                        // Draw the other line one map
                        if (this.centerlineList.length > 1) {
                            additionalLine = this.centerlineList.find(function (l) { return l.id !== _this.currentId; });
                            this.resoCenterService.drawAdditionalRcSubject.next({
                                recordsInfo: [{
                                        wkt: additionalLine.props[this.attrIndexService.geomColManual],
                                        id: additionalLine.id
                                    }]
                            });
                        }
                        // // sort by fromAddressLeft value ascending
                        // 	this.centerlineList.sort((a, b) => {
                        // 		const fromAddrL1 = a.props[this.fromAddrLeftCol.prop];
                        // 		const fromAddrL2 = b.props[this.fromAddrLeftCol.prop];
                        // 		if (fromAddrL1 !== fromAddrL2) {
                        // 			if (fromAddrL1 && fromAddrL2) {
                        // 				if (fromAddrL1 > fromAddrL2) {
                        // 					return 1;
                        // 				} else {
                        // 					return -1;
                        // 				}
                        // 			} else if (!fromAddrL2) {
                        // 				return 1;
                        // 			} else if (!fromAddrL1) {
                        // 				return -1;
                        // 			}
                        // 		} else {
                        // 			const fromAddrR1 = a.props[this.fromAddrRightCol.prop];
                        // 			const fromAddrR2 = b.props[this.fromAddrRightCol.prop];
                        // 			if (fromAddrR1 !== fromAddrR2) {
                        // 				if (fromAddrR1 && fromAddrR2) {
                        // 					if (fromAddrR1 > fromAddrR2) {
                        // 						return 1;
                        // 					} else {
                        // 						return -1;
                        // 					}
                        // 				} else if (!fromAddrR2) {
                        // 					return 1;
                        // 				} else if (!fromAddrR1) {
                        // 					return -1;
                        // 				}
                        // 			}
                        // 		}
                        // 	})
                        this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);
                        this.updateRAO();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionRAOComponent.prototype.calculateDirection = function (l) {
        var wkt = l.props[this.attrIndexService.geomColManual];
        if (!wkt) {
            return;
        }
        var wktFormat = new WKT();
        var olGeom = wktFormat.readGeometry(wkt);
        var direction = this.mapSharedService.getLineFeatureDirection(olGeom);
        l.direction = direction;
        if (direction === 'E' || direction === 'W') {
            l.horizontalVertical = 'hori';
        }
        else if (direction === 'N' || direction === 'S') {
            l.horizontalVertical = 'vert';
        }
    };
    ResolutionRAOComponent.prototype.calculateRelativePosition = function () {
        try {
            var line1 = this.centerlineList[0];
            var line2 = this.centerlineList[1];
            var wktFormat = new WKT();
            var wkt1 = this.centerlineList[0].props[this.attrIndexService.geomColManual];
            var wkt2 = this.centerlineList[1].props[this.attrIndexService.geomColManual];
            var line1Geom = wkt1 ? wktFormat.readGeometry(wkt1) : null;
            var line2Geom = wkt2 ? wktFormat.readGeometry(wkt2) : null;
            var relativePosition = 'leftRight';
            if (line1 && line2 && line1Geom && line2Geom) {
                var bbox1 = line1Geom.getExtent(), bbox2 = line2Geom.getExtent();
                var xmin1 = bbox1[0], xmax1 = bbox1[2], ymin1 = bbox1[1], ymax1 = bbox1[3];
                var xmin2 = bbox2[0], xmax2 = bbox2[2], ymin2 = bbox2[1], ymax2 = bbox2[3];
                if (line1.horizontalVertical === line2.horizontalVertical) {
                    // Both lines are horizontal
                    if (line1.horizontalVertical === 'hori') {
                        var shorterX = Math.min(xmax1 - xmin1, xmax2 - xmin2);
                        var overlapRange = this.mapSharedService.getRangeOverlap([xmin1, xmax1], [xmin2, xmax2]);
                        if (overlapRange) {
                            var overlap = overlapRange[1] - overlapRange[0];
                            if (overlap > shorterX / 2) {
                                relativePosition = 'upperLower';
                            }
                        }
                        if (relativePosition === 'leftRight') {
                            if (xmin1 <= xmin2) {
                                line1.relativePosition = 'left';
                                line2.relativePosition = 'right';
                            }
                            else {
                                line1.relativePosition = 'right';
                                line2.relativePosition = 'left';
                            }
                        }
                        else if (relativePosition === 'upperLower') {
                            line1.relativePosition = 'upper';
                            line2.relativePosition = 'lower';
                            var overlapStartX = overlapRange[0];
                            var parser = this.jstsService.getJstsParser();
                            var jstsYLine = parser.read(new LineString([[overlapStartX, Math.min(ymin1, ymin2)], [overlapStartX, Math.max(ymax1, ymax2)]]));
                            var jstsLine1 = parser.read(line1Geom);
                            var jstsLine2 = parser.read(line2Geom);
                            // OverlayOp.overlayOp
                            var intersection1 = this.jstsService.getJstsOverlayOp().intersection(jstsLine1, jstsYLine); // jstsLine1.intersection(jstsYLine);
                            var intersection2 = this.jstsService.getJstsOverlayOp().intersection(jstsLine2, jstsYLine); // jstsLine2.intersection(jstsYLine);
                            if (intersection1 && intersection2) {
                                var coord1 = intersection1.getCoordinates()[0];
                                var coord2 = intersection2.getCoordinates()[0];
                                if (coord1 && coord2 && coord1.y < coord2.y) {
                                    line1.relativePosition = 'lower';
                                    line2.relativePosition = 'upper';
                                }
                            }
                        }
                    }
                    // Both lines are vertical
                    else if (line1.horizontalVertical === 'vert') {
                        var shorterY = Math.min(ymax1 - ymin1, ymax2 - ymin2);
                        var overlapRange = this.mapSharedService.getRangeOverlap([ymin1, ymax1], [ymin2, ymax2]);
                        relativePosition = 'upperLower';
                        if (overlapRange) {
                            var overlap = overlapRange[1] - overlapRange[0];
                            if (overlap > shorterY / 2) {
                                relativePosition = 'leftRight';
                            }
                        }
                        if (relativePosition === 'upperLower') {
                            if (ymin1 <= ymin2) {
                                line1.relativePosition = 'lower';
                                line2.relativePosition = 'upper';
                            }
                            else {
                                line1.relativePosition = 'upper';
                                line2.relativePosition = 'lower';
                            }
                        }
                        else if (relativePosition === 'leftRight') {
                            line1.relativePosition = 'left';
                            line2.relativePosition = 'right';
                            var overlapStartY = overlapRange[1];
                            var parser = this.jstsService.getJstsParser();
                            var jstsXLine = parser.read(new LineString([[Math.min(xmin1, xmin2), overlapStartY], [Math.max(xmax1, xmax2), overlapStartY]]));
                            var jstsLine1 = parser.read(line1Geom);
                            var jstsLine2 = parser.read(line2Geom);
                            var intersection1 = this.jstsService.getJstsOverlayOp().intersection(jstsLine1, jstsXLine); // jstsLine1.intersection(jstsXLine);
                            var intersection2 = this.jstsService.getJstsOverlayOp().intersection(jstsLine2, jstsXLine); // jstsLine2.intersection(jstsXLine);
                            if (intersection1 && intersection2) {
                                var coord1 = intersection1.getCoordinates()[0];
                                var coord2 = intersection2.getCoordinates()[0];
                                if (coord1 && coord2 && coord1.x > coord2.x) {
                                    line1.relativePosition = 'right';
                                    line2.relativePosition = 'left';
                                }
                            }
                        }
                    }
                }
                else {
                    line1.relativePosition = 'left';
                    line2.relativePosition = 'right';
                }
            }
            this.relativePosition = relativePosition;
            if (line1.horizontalVertical === line2.horizontalVertical) {
                if (line1.horizontalVertical === 'hori' && this.relativePosition === 'leftRight') {
                    this.isRelativePosConsistentWithDirection = true;
                }
                else if (line1.horizontalVertical === 'vert' && this.relativePosition === 'upperLower') {
                    this.isRelativePosConsistentWithDirection = true;
                }
                else {
                    this.isRelativePosConsistentWithDirection = false;
                }
            }
            else {
                this.isRelativePosConsistentWithDirection = false;
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    // Is the terminal point of one road connected with the terminal point of the other road
    ResolutionRAOComponent.prototype.checkRoadsConnected = function (roadGeomA, roadGeomB) {
        var connected = false;
        if (roadGeomA && roadGeomB) {
            var coordsA = roadGeomA.getCoordinates();
            var startPointA = coordsA[0];
            var endPointA = coordsA[coordsA.length - 1];
            var coordsB = roadGeomB.getCoordinates();
            var startPointB = coordsB[0];
            var endPointB = coordsB[coordsB.length - 1];
            if (this.mapSharedService.isCoordsEqual(startPointA, startPointB)) {
                connected = true;
            }
            else if (this.mapSharedService.isCoordsEqual(startPointA, endPointB)) {
                connected = true;
            }
            else if (this.mapSharedService.isCoordsEqual(endPointA, startPointB)) {
                connected = true;
            }
            else if (this.mapSharedService.isCoordsEqual(endPointA, endPointB)) {
                connected = true;
            }
        }
        this.isRoadsConnected = connected;
    };
    ResolutionRAOComponent.prototype.checkRoadsRings = function (roadGeom1, roadGeom2, line1, line2) {
        var firstEndConnected = false;
        var secondEndConnected = false;
        if (roadGeom1 && roadGeom2) {
            var coords1 = roadGeom1.getCoordinates();
            var startPoint1 = coords1[0];
            var endPoint1 = coords1[coords1.length - 1];
            var coords2 = roadGeom2.getCoordinates();
            var startPoint2 = coords2[0];
            var endPoint2 = coords2[coords2.length - 1];
            var relativePosition = void 0;
            if (this.relativePosition === 'leftRight') {
                relativePosition = 'hori';
            }
            else if (this.relativePosition === 'upperLower') {
                relativePosition = 'verti';
            }
            if (line1.horizontalVertical === line2.horizontalVertical && line1.horizontalVertical !== relativePosition) {
                var firstPoint1 = void 0, secondPoint1 = void 0, firstPoint2 = void 0, secondPoint2 = void 0;
                if (line1.horizontalVertical === 'hori') {
                    if (startPoint1[0] <= endPoint1[0]) {
                        firstPoint1 = startPoint1;
                        secondPoint1 = endPoint1;
                    }
                    else {
                        firstPoint1 = endPoint1;
                        secondPoint1 = startPoint1;
                    }
                    if (startPoint2[0] <= endPoint2[0]) {
                        firstPoint2 = startPoint2;
                        secondPoint2 = endPoint2;
                    }
                    else {
                        firstPoint2 = endPoint2;
                        secondPoint2 = startPoint2;
                    }
                }
                else if (line1.horizontalVertical === 'vert') {
                    if (startPoint1[1] >= endPoint1[1]) {
                        firstPoint1 = startPoint1;
                        secondPoint1 = endPoint1;
                    }
                    else {
                        firstPoint1 = endPoint1;
                        secondPoint1 = startPoint1;
                    }
                    if (startPoint2[1] >= endPoint2[1]) {
                        firstPoint2 = startPoint2;
                        secondPoint2 = endPoint2;
                    }
                    else {
                        firstPoint2 = endPoint2;
                        secondPoint2 = startPoint2;
                    }
                }
                if (this.mapSharedService.isCoordsEqual(firstPoint1, firstPoint2)) {
                    firstEndConnected = true;
                }
                if (this.mapSharedService.isCoordsEqual(secondPoint1, secondPoint2)) {
                    secondEndConnected = true;
                }
            }
        }
        this.firstEndConnected = firstEndConnected;
        this.secondEndConnected = secondEndConnected;
        if (this.firstEndConnected && this.secondEndConnected) {
            this.connectedEnd = 'both';
        }
        else if (this.firstEndConnected) {
            this.connectedEnd = 'first';
        }
        else if (this.secondEndConnected) {
            this.connectedEnd = 'second';
        }
        else {
            this.connectedEnd = null;
        }
    };
    ResolutionRAOComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentCardSub = this.activityService.currentCardBS.subscribe(function (data) {
            if (data) {
                _this.currentId = data.id;
            }
        });
        this.flipRoadSub = this.flipRoadService.afterFlipRoadSubject.subscribe(function (data) {
            if (!data || !data.id) {
                return;
            }
            if (!data.flipedWkt && (!data.transposeCols || !data.transposeCols.length)) {
                return;
            }
            var id = data.id;
            var line = _this.centerlineList.find(function (i) { return i.id === id; });
            if (data.transposeCols && data.transposeCols && data.transposeCols.length) {
                data.transposeCols.forEach(function (c) {
                    _this.resoCenterService.onEditRecord(line, { prop: c.leftProp });
                    _this.resoCenterService.onEditRecord(line, { prop: c.rightProp });
                });
            }
            if (data.flipedWkt) {
                _this.resoCenterService.onEditRecord(line, null, true);
            }
            _this.calculateDirection(line);
            _this.updateRAO();
            _this.updateParity(line);
            _this.edit.emit();
        });
    };
    ResolutionRAOComponent.prototype.ngOnChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!changes.resolverFeed) return [3 /*break*/, 2];
                        console.log('On feed change, RAO');
                        return [4 /*yield*/, this.onFeedChange()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ResolutionRAOComponent.prototype.ngOnDestroy = function () {
        this.currentCardSub.unsubscribe();
        this.flipRoadSub.unsubscribe();
    };
    return ResolutionRAOComponent;
}());
export { ResolutionRAOComponent };
